<div class="new-menu-hamburger">
  <button (click)="toggleSidebar()">
    <i class="pi pi-bars"></i>
  </button>
</div>

<div class="sidebar" [ngClass]="{'sidebar-expanded': isExpanded, 'sidebar-collapsed': !isExpanded}">

  <!-- Header del sidebar -->
  <div class="d-flex align-items-center p-3 border-bottom gap-2"
    [ngClass]="{'justify-content-between flex-row-reverse': isExpanded, 'flex-column': !isExpanded}">

    <!-- Botón para colapsar/expandir -->
    <button class="btn btn-link text-white p-1" (click)="toggleSidebar()">
      <i class="pi" [ngClass]="isExpanded ? 'pi-angle-left' : 'pi-angle-right'"></i>
    </button>

    <!-- Logo y título (visible solo cuando está expandido) -->
    <div class="d-flex align-items-center">
      <button class="d-flex align-items-center w-[32px] btn text-start p-2 justify-content-between border-0"
        (click)="navigateToWindow('/main')">
        <img src="../../../assets/images/Icono1.ico.ico" alt="Cervino Logo" class="rounded" width="32" height="32">
      </button>

      <div *ngIf="isExpanded" class="sidebar-text">
        <h1 class="fs-4 fw-bold m-0 text-white">Cervino</h1>
      </div>
    </div>
  </div>

  <!-- Menú de navegación -->
  <div class="sidebar-menu-container p-2">

    <!-- Skeleton Loader mientras carga -->
    <div *ngIf="isLoading " class="loading-skeleton">
      <div *ngFor="let item of [1,2,3,4,5,6]" class="skeleton-item mb-3 w-100">
        <div class="d-flex align-items-center">
          <p-skeleton shape="rectangle" [width]="isExpanded ? '6rem' : '2rem'" height="2rem" styleClass="me-2"
            [ngClass]="{'me-0': !isExpanded}">
          </p-skeleton>
        </div>
        <!-- Skeleton para submenús -->
        <div *ngIf="isExpanded && item <= 3" class="ms-4 mt-2">
          <div *ngFor="let subItem of [1,2,3,5,6,7]" class="d-flex align-items-center mb-2 w-100">
            <p-skeleton shape="rectangle" width="10rem" height="2rem" styleClass="me-2"></p-skeleton>
          </div>
        </div>
      </div>
    </div>

    <!-- Menú real -->
    <div *ngIf="isExpanded" class="mb-2">
      <input type="text" class="form-control form-control-sm" placeholder="Buscar" [(ngModel)]="searchTerm" />
    </div>

    <ul class="nav flex-column" *ngIf="!isLoading">
      <ng-container *ngFor="let module of modules">

        <li class="nav-item mb-2" *ngIf="hasMatches(module)">

          <!-- Módulo con ventanas -->
          <div *ngIf="module.windows && module.windows.length > 0 && hasMatches(module)">
            <!-- Botón del módulo principal -->
            <div class="container-module" [ngClass]="{'active-module': isModuleActive(module)}"
              pTooltip="{{isExpanded ? '' : module.name}}" showDelay="300" hideDelay="200">
              <button class="d-flex align-items-center w-100 btn text-start p-2 justify-content-between"
                (click)="toggleModule(module)">
                <div class="d-flex align-items-center gap-2">
                  <span class="icon material-icons material-symbols-outlined" color="white">
                    {{module.iconModule}}
                  </span>
                  <span class="nav-link-text" *ngIf="isExpanded">{{module.name}}</span>
                </div>

                <i *ngIf="isExpanded" class="pi pi-chevron-down transition-transform"
                  [ngClass]="{'rotated': isModuleExpanded(module.moduleId)}">
                </i>
              </button>
            </div>

            <!-- Submenús -->
            <ul class="nav nav-sub-link flex-column ms-3 mt-1" *ngIf="module.windows &&
          ((!searchTerm && isExpanded && isModuleExpanded(module.moduleId)) ||
            (searchTerm && isExpanded && hasMatches(module)))">
              <li class="nav-item" *ngFor="let window of getFilteredWindows(module)">
                <div class="container-module" [ngClass]="{'active-module': isWindowActive(window)}">
                  <a class="nav-link submenu-item d-flex align-items-center w-100 btn btn-link text-start"
                    [routerLink]="'/' + window.urlWindow" (click)="onWindowLinkClick($event)">
                    <span>{{ window.labelName }}</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>

          <!-- Módulo sin ventanas -->
          <button *ngIf="!module.windows || module.windows.length === 0"
            class="nav-link d-flex align-items-center w-100 btn btn-link text-start justify-content-between"
            (click)="navigateToModule(module)" pTooltip="{{isExpanded ? '' : module.name}}" showDelay="300"
            hideDelay="200">
            <span class="nav-link-text" *ngIf="isExpanded">{{module.name}}</span>
          </button>
        </li>
      </ng-container>
    </ul>
  </div>

  <!-- Footer -->
  <div *ngIf="isExpanded && !isLoading" class="p-2 text-center border-top mt-auto">
    <small class="text-white-50">© 2023 Altos Software</small>
  </div>
</div>